import React from "react";
import Screenshot from "../imgs/me.png";

export const About = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img src={Screenshot} alt="Cairtean" className="screenshot" />
      </div>
      <div className="itemContained itemExplainer">
        <center>
          <span className="itemTitle">Help out</span>
          <br />
          <br />

          <span className="itemBody">
            I make all of this on my own for free - but you can make a donation to support
            these and future Gaelic-learning apps here
          </span>
        </center>
      </div>
    </div>
  );
};
